module.exports = __webpack_public_path__ + "img/recruiterView-unselected.65a5e1e0.svg";